import { business } from './business';

export const chatbotQuickReplies = [
  '아이로그가 뭐예요?',
  '학원에 어떻게 입점하나요?',
  '어떤 효과가 있나요?',
  '도입 문의는 어떻게 하나요?',
];

export const ILOG_KNOWLEDGE = `
당신은 아이로그(i-LOG) 공식 상담 챗봇입니다.
친절하고 짧고 명확한 한국어로 답변하세요. 확실하지 않은 가격/계약 조건은 단정하지 말고 도입 문의를 안내하세요.

[서비스 한줄 정의]
아이로그는 학원·교육기관에 입점하는 스마트 포토부스입니다.
아이가 체험한 순간을 사진으로 기록하고, AI가 흥미·관심사를 분석해 다음 교육 경험을 추천합니다.

[핵심 흐름]
1) Capture: 아이가 직접 경험한 순간을 포토부스로 기록
2) Learn: AI가 흥미와 관심사를 분석
3) Recommend: 아이에게 맞는 다음 교육/프로그램 추천

[학원/교육기관 가치]
- 체험형 마케팅: 아이들이 자연스럽게 참여하는 콘텐츠
- 맞춤 프로그램 연결: 관심사 기반 추천으로 상담·등록 연결
- 신규 고객 확보: 체험 → 상담 → 등록 흐름 지원
- 성장 기록: 체험이 쌓일수록 관심사와 경험 변화를 확인

[학부모 가치]
- 광고/입소문이 아니라 실제 체험 기록 중심
- 아이의 직접 반응과 누적 성장 기록 기반 교육 선택
- 다른 아이가 좋아하는 교육보다 우리 아이에게 맞는 교육 탐색

[운영사 정보]
- 상호: ${business.name}
- 제품명: ${business.productName} (${business.brandEn})
- 대표: ${business.representative}
- 사업자등록번호: ${business.registrationNumber}
- 주소: ${business.address}
- 문의 이메일: ${business.email}
- 서비스 이용: https://iplay.kro.kr
- 웹사이트에서 '아이로그 부스 도입 문의하기'로 이름/전화/주소 문의 접수 가능

[답변 규칙]
- 아이로그/교육/포토부스/입점/도입/학원 관련 질문에 집중
- 무관한 주제는 간단히 거절하고 아이로그 관련 질문으로 유도
- 답변은 2~5문장 정도로 간결하게
- 필요하면 마지막에 도입 문의 또는 iplay.kro.kr 안내
`.trim();

export const FAQ_FALLBACKS = [
  {
    keywords: ['안녕', '헬로', 'hello', 'hi'],
    answer:
      '안녕하세요! 아이로그 상담 챗봇입니다. 학원 입점, 도입 방법, 효과, 문의 방법 등을 물어보시면 안내해 드릴게요.',
  },
  {
    keywords: ['뭐야', '무엇', '소개', '어떤서비스', '아이로그', 'ilog', 'i-log', '포토부스'],
    answer:
      '아이로그는 학원·교육기관에 입점하는 스마트 포토부스예요. 아이의 체험을 사진으로 남기고 AI가 관심사를 분석해, 다음 교육 경험을 추천합니다.',
  },
  {
    keywords: ['입점', '도입', '설치', '배치', '학원', '교육기관', '어떻게'],
    answer:
      '아이로그는 학원·교육 공간에 부스를 도입하는 방식입니다. 아이들이 체험에 참여하고, 그 기록이 관심사 분석과 프로그램 추천·상담으로 연결돼요. 도입을 검토 중이시면 사이트에서 ‘아이로그 부스 도입 문의하기’로 남겨 주세요.',
  },
  {
    keywords: ['효과', '장점', '왜', '고객', '마케팅', '추천', '도움'],
    answer:
      '아이에게는 재미있는 체험과 성장 기록이 되고, 학원에는 체험형 마케팅·맞춤 프로그램 연결·신규 고객 확보에 도움이 됩니다. 일회성 체험이 아니라 누적 기록 기반으로 상담·등록까지 이어갈 수 있어요.',
  },
  {
    keywords: ['가격', '비용', '요금', '얼마', '견적'],
    answer:
      '도입 규모와 운영 환경에 따라 안내가 달라질 수 있어요. 정확한 견적은 사이트의 도입 문의(이름·전화번호·주소)로 남겨 주시면 상담 시 안내드리겠습니다.',
  },
  {
    keywords: ['문의', '상담', '연락', '전화', '신청', '접수'],
    answer:
      `도입 문의는 웹사이트의 ‘아이로그 부스 도입 문의하기’에서 접수할 수 있어요. 이메일 문의는 ${business.email} 로도 가능합니다.`,
  },
  {
    keywords: ['시작', '이용', '앱', '서비스', '사이트'],
    answer:
      '아이로그 서비스 이용은 https://iplay.kro.kr 에서 시작할 수 있어요. 학원 입점·부스 도입 상담은 사이트 문의하기를 이용해 주세요.',
  },
  {
    keywords: ['ai', '분석', '기록', '사진', '캡처', 'capture', 'learn', 'recommend', '흐름'],
    answer:
      '아이가 포토부스에서 순간을 기록하면, AI가 흥미·관심 영역을 분석하고 맞춤 활동/교육을 추천합니다. 사진만 남기는 일반 포토부스와 달리 Capture → Learn → Recommend 흐름이 핵심이에요.',
  },
  {
    keywords: ['회사', '사업자', '대표', '주소', '아이플레이'],
    answer:
      `운영사는 ${business.name}입니다. 대표 ${business.representative}, 사업자등록번호 ${business.registrationNumber}, 주소는 ${business.address} 입니다.`,
  },
  {
    keywords: ['학부모', '부모', '아이', '관심사', '교육선택'],
    answer:
      '학부모 입장에서는 광고·입소문보다 아이의 실제 체험 기록과 반응을 바탕으로 교육을 고를 수 있어요. 체험이 쌓일수록 관심사와 경험 변화도 한눈에 확인할 수 있습니다.',
  },
];

export function findFaqAnswer(question) {
  const normalized = question.toLowerCase().replace(/\s+/g, '');
  let best = null;
  let score = 0;

  FAQ_FALLBACKS.forEach((item) => {
    const hits = item.keywords.filter((keyword) =>
      normalized.includes(keyword.toLowerCase().replace(/\s+/g, ''))
    ).length;
    if (hits > score) {
      score = hits;
      best = item.answer;
    }
  });

  return score > 0 ? best : null;
}

export function buildLocalAnswer(question) {
  const faq = findFaqAnswer(question);
  if (faq) return faq;

  const normalized = question.toLowerCase();
  const related =
    /아이로그|ilog|i-log|포토|부스|학원|교육|입점|도입|체험|문의|상담/.test(
      normalized
    );

  if (!related) {
    return '저는 아이로그(학원 입점형 스마트 포토부스) 안내를 도와드려요. 예를 들어 “아이로그가 뭐예요?”, “입점은 어떻게 하나요?”, “효과가 뭐예요?”처럼 물어봐 주세요.';
  }

  return `아이로그는 학원에 입점하는 스마트 포토부스로, 체험 기록 → AI 분석 → 맞춤 추천 흐름을 제공합니다. 더 구체적인 내용은 ‘아이로그가 뭐예요?’, ‘입점 방법’, ‘도입 문의’로 질문해 주시거나 사이트의 도입 문의를 이용해 주세요. (${business.email})`;
}
